import { useContext } from 'react'

import StoresContext from '@/utils/StoresContext'

export default function usePhoneCountry() {
  const { appStore } = useContext(StoresContext)
  const { restaurantCountry, language } = appStore.state
  return restaurantCountry && ['en', 'uk'].includes(restaurantCountry) ? 'gb' : restaurantCountry || language
}
